import React from 'react'
import { ICONS } from '@Const/common'
import { WorkModel } from '@Entities/work/work'
import WorkItemsSimpleTable from '@Components/Tables/WorkItemsSimpleTable'
import { FileReviewExpandWorks } from '@Scenes/WorkScenes/Steps/FileReviewStep/file-review-expand-works'

interface FileReviewErrorsProps {
    numErrors: number
    errorWorksExpanded: boolean
    expandSection: (section: FileReviewExpandWorks) => void
    contractSection: (section: FileReviewExpandWorks) => void
    worksWithError: WorkModel[]
}

const FileReviewErrors = (props: FileReviewErrorsProps) => {
    const { numErrors, errorWorksExpanded, expandSection, contractSection, worksWithError } = props

    return (
        <section className="items-container">
            <div
                className="items-header"
                onClick={() => {
                    errorWorksExpanded
                        ? contractSection(FileReviewExpandWorks.error)
                        : expandSection(FileReviewExpandWorks.error)
                }}
            >
                <p className="type-title bold">Needs Attention ( {numErrors} )</p>
                {errorWorksExpanded
                    ? numErrors && <img src={ICONS.minus} alt="contract" />
                    : numErrors && <img src={ICONS.add} alt="expand" />}
            </div>
            {errorWorksExpanded && (
                <WorkItemsSimpleTable workModelList={worksWithError} valid={false} disableView={false} />
            )}
        </section>
    )
}

export default FileReviewErrors
